import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateVisibleStationsDisplay = (
  show: StationsState['visibleStations']['show']) => stationsActions
  .setVisibleStationsDisplay(show);
